module.exports = __webpack_public_path__ + "static/media/logo-iscab.0fd3d446.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/img/logo-iscab.png
// module id = 864
// module chunks = 0